import { render, staticRenderFns } from "./VacancyMessageArea.vue?vue&type=template&id=2e806a92&scoped=true"
import script from "./VacancyMessageArea.vue?vue&type=script&lang=js"
export * from "./VacancyMessageArea.vue?vue&type=script&lang=js"
import style0 from "./VacancyMessageArea.vue?vue&type=style&index=0&id=2e806a92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e806a92",
  null
  
)

export default component.exports